import { render, staticRenderFns } from "./panel-header.vue?vue&type=template&id=3b261f7d&scoped=true&"
import script from "./panel-header.vue?vue&type=script&lang=js&"
export * from "./panel-header.vue?vue&type=script&lang=js&"
import style0 from "./panel-header.vue?vue&type=style&index=0&id=3b261f7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b261f7d",
  null
  
)

export default component.exports